import { ISelectItem } from '@lla-platform/core/core-ui'

export enum MaterialSource {
  Inventory = 'Inventory',
  Purchase = 'Purchase',
  Advanced = 'Advanced',
  ReturnedItem = 'ReturnedItem',
  Unspecified = 'Unspecified'
}

export const MaterialSourceToLabel: { [key: string]: string } = {
  Inventory: 'Inventory',
  Purchase: 'Purchase',
  Advanced: 'Advanced',
  ReturnedItem: 'Returned Item',
  Unspecified: 'Unspecified'
}

export const MaterialSourceItems: ISelectItem[] = Object.values(MaterialSource).map((value) => ({
  label: MaterialSourceToLabel[value],
  value
}))
